import { render } from "./submittedUpload.vue?vue&type=template&id=770ac31a"
import script from "./submittedUpload.vue?vue&type=script&lang=js"
export * from "./submittedUpload.vue?vue&type=script&lang=js"

import "./submittedUpload.vue?vue&type=style&index=0&id=770ac31a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__